module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main hidden-print"
  }, [_c('header', {
    class: [_vm.isScrolling && 'scrolling', _vm.openMenuMobile && _vm.window.document.webview ? 'open-menu-webview' : _vm.openMenuMobile && 'open-menu']
  }, [_c('div', {
    staticClass: "header-container"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'inicio'
      }
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    class: {
      'logo-pending-scroll-version': !_vm.isMobile && _vm.isScrolling
    },
    staticStyle: {
      "pointer-events": "none"
    },
    attrs: {
      "src": ("../../static/" + _vm.logo),
      "alt": "Logo Move Mais"
    }
  })])]), _vm._v(" "), (!_vm.openMenuMobile) ? _c('div', {
    staticClass: "button-menu",
    on: {
      "click": function($event) {
        _vm.openMenuMobile = true
      }
    }
  }, [_c('img', {
    staticClass: "mobile-icon",
    attrs: {
      "src": require("../../static/HotdogNewRoxo_375.svg"),
      "alt": "HotdogNewRoxo_375"
    }
  })]) : _c('div', {
    staticClass: "button-menu",
    on: {
      "click": function($event) {
        _vm.openMenuMobile = false
      }
    }
  }, [_c('i', {
    staticClass: "icon-cancel mobile-icon",
    staticStyle: {
      "font-size": "19px",
      "margin-right": "20px"
    }
  })])], 1), _vm._v(" "), (_vm.openMenuMobile || !_vm.isMobile) ? [_c('div', {
    staticClass: "menu-container",
    on: {
      "click": function($event) {
        _vm.openMenuMobile = false
      }
    }
  }, [_c('router-link', {
    staticClass: "item-menu",
    attrs: {
      "tag": "div",
      "to": {
        name: 'services'
      }
    }
  }, [_c('i', {
    staticClass: "icon-coin2 mobile-icon"
  }), _vm._v(" "), _c('span', [_vm._v("Planos")])]), _vm._v(" "), _c('router-link', {
    staticClass: "item-menu",
    attrs: {
      "tag": "div",
      "to": {
        name: 'promo-toll-ticket'
      }
    }
  }, [_c('i', {
    staticClass: "icon-toll-ticket mobile-icon"
  }), _vm._v(" "), _c('span', [_vm._v("Vale-pedágio")])]), _vm._v(" "), _c('router-link', {
    staticClass: "item-menu",
    attrs: {
      "tag": "div",
      "to": {
        name: 'range'
      }
    }
  }, [_c('i', {
    staticClass: "icon-pin mobile-icon"
  }), _vm._v(" "), _c('span', [_vm._v("Cobertura")])]), _vm._v(" "), _c('router-link', {
    staticClass: "item-menu",
    attrs: {
      "tag": "div",
      "to": {
        name: 'move-mais'
      }
    }
  }, [_c('i', {
    staticClass: "icon-move-plus mobile-icon"
  }), _vm._v(" "), _c('span', [_vm._v("A Move Mais")])]), _vm._v(" "), _c('router-link', {
    staticClass: "item-menu",
    attrs: {
      "tag": "div",
      "to": {
        name: 'withdrawall-points'
      }
    }
  }, [_c('img', {
    staticClass: "mobile-icon icon-img",
    attrs: {
      "src": require("../../static/retirar_tag.svg")
    }
  }), _vm._v(" "), _c('span', [_vm._v("Retirar TAG")])]), _vm._v(" "), _c('router-link', {
    staticClass: "item-menu",
    attrs: {
      "tag": "div",
      "to": {
        name: 'contact'
      }
    }
  }, [_c('i', {
    staticClass: "icon-mail mobile-icon"
  }), _vm._v(" "), _c('span', [_vm._v("Contato")])]), _vm._v(" "), _c('div', {
    staticClass: "item-menu"
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.open('https://blog.movemais.net/')
      }
    }
  }, [_c('img', {
    staticClass: "mobile-icon icon-img",
    attrs: {
      "src": require("../../static/blog.svg")
    }
  }), _vm._v(" "), _c('span', [_vm._v("blog+")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "item-menu account",
    attrs: {
      "tag": "div",
      "to": {
        name: 'login'
      }
    }
  }, [_c('i', {
    staticClass: "icon-avatar mobile-icon"
  }), _vm._v(" "), _c('span', [_vm._v("Minha Conta")])])], 1), _vm._v(" "), _vm._m(0)] : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer mobile"
  }, [_c('span', [_vm._v("Acompanhe-nos")]), _vm._v(" "), _c('div', {
    staticClass: "media-container"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/MoveMais/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "icon-facebook mobile",
    staticStyle: {
      "font-size": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/movemais/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "icon-instagram mobile",
    staticStyle: {
      "font-size": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('a', {
    attrs: {
      "href": "https://www.linkedin.com/company/move-mais/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "icon-linkedin mobile",
    staticStyle: {
      "font-size": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/Move_Mais",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "icon-twitter mobile",
    staticStyle: {
      "font-size": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/user/movemais",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "icon-youtube mobile",
    staticStyle: {
      "font-size": "15px"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-6246e9f0!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/app-header.vue
// module id = 2147
// module chunks = 1